module.exports = __webpack_public_path__ + "img/icon-ctr.0e3e61b1.svg";